<template>
  <section>
    <GroupCheckboxesWithValidation
      v-model="checkedThematiquesLabels"
      :label="$t('instruction.thematique-traitee')"
      :data="allThematiquesLabels()"
      :vertical-display="true"
      :input-label="$t('instruction.AUTRE')"
      :ext-input-value="internalProjetAnnuel.thematiqueAutre"
      vid="thematiques"
      :disabled="readOnly"
      @manual-change="changeThematiques"
      @input-change="changeThematiqueAutre"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import GroupCheckboxesWithValidation from "@/views/inputs/GroupCheckBoxesWithValidation.vue"
import { EnumHelper } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "InstructionThematiques",
  components: {
    GroupCheckboxesWithValidation,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["projet-annuel-updated"],
  data() {
    return {
      internalProjetAnnuel: new ProjetAnnuelDTO(),
      allThematiques: EnumHelper.allThematiques,
      checkedThematiquesLabels: [] as string[],
    }
  },
  watch: {
    projetAnnuel(): void {
      this.internalProjetAnnuel = { ...this.projetAnnuel }
      this.refreshChecked()
    },
  },
  created(): void {
    this.internalProjetAnnuel = { ...this.projetAnnuel }
    this.refreshChecked()
  },
  methods: {
    refreshChecked(): void {
      this.checkedThematiquesLabels = this.internalProjetAnnuel.thematique.map((thematique) => {
        return this.$t("instruction." + thematique).toString()
      })
      if (this.internalProjetAnnuel.thematiqueAutre) {
        this.checkedThematiquesLabels.push(this.$t("instruction.AUTRE").toString())
      }
    },

    allThematiquesLabels(): string[] {
      return this.allThematiques.map((thematique) => {
        return this.$t("instruction." + thematique).toString()
      })
    },

    changeThematiques(): void {
      const updatedProjet = { ...this.internalProjetAnnuel }
      updatedProjet.thematique = this.allThematiques.filter((thematique) => {
        return (
          this.checkedThematiquesLabels.indexOf(this.$t("instruction." + thematique).toString()) >
          -1
        )
      })
      if (this.checkedThematiquesLabels.indexOf(this.$t("instruction.AUTRE").toString()) == -1) {
        updatedProjet.thematiqueAutre = ""
      }
      this.$emit("projet-annuel-updated", updatedProjet)
    },

    changeThematiqueAutre(newValue: string): void {
      const updatedProjet = { ...this.internalProjetAnnuel }
      
      const indexAutre = this.checkedThematiquesLabels.indexOf(
        this.$t("instruction.AUTRE").toString(),
      )
      
      // Only update value if AUTRE checkbox is checked
      if (indexAutre !== -1) {
        updatedProjet.thematiqueAutre = newValue
      } else {
        updatedProjet.thematiqueAutre = ""
      }
      
      this.$emit("projet-annuel-updated", updatedProjet)
    },
  },
})
</script>
